import React, { useEffect, useState } from "react";
import { useRef } from "react";

import {
  FaArrowCircleRight,
  FaBook,
  FaDownload,
  FaEnvelope,
  FaGraduationCap,
  FaHands,
  FaLandmark,
  FaLanguage,
  FaTrophy,
  FaUserAlt,
} from "react-icons/fa";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import Footer from "../../../Components/Footer/footer";
import { FaRightToBracket } from "react-icons/fa6";
import { useParams } from "react-router";
import performRequest from "../../../APIs/request";
import { Toast } from "../../CustomComponent/toast";
import { useSelector } from "react-redux";
const AppliedCandidateResume = () => {
  const [candidateDetails, setCandidateDetails] = useState("");
  const store = useSelector((store) => store?.userLogin);
  const [viewApplicants, setViewApplicants] = useState();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  let { id } = useParams();
  const printRef = useRef();
  const handleDownloadPdf = async () => {
    const element = printRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, {
      allowTaint: true,
      useCORS: true,
    });

    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    // const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("print.pdf");
  };
  const handleViewApplicantList = (id) => {
    setLoading(true);
    performRequest("GET", `/applyedcandidate/applyedcandidatebyid/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setCandidateDetails(res.data?.usermodel?.resumemodel);
          setViewApplicants(res.data);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    if (id) {
      handleViewApplicantList(id);
    }
  }, [id, refresh]);

  const handleShortlist = (id) => {
    performRequest("PATCH", `/applyedcandidate/updateapplyedcandidate/${id}`, {
      shortlistBy: store.user?.UserId,
      shortlistByRole: store.user?.Role,
      shortlistStatus: true,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Candidate shortlisted successfully");
          setRefresh(!refresh);
        } else {
          Toast("error", "Server Error");
        }
      })
      .catch((err) => {
        console.error("Error", err);
        if (err.response.status === 401) {
          Toast("error", err.response.data.message);
        } else {
          Toast("error", "Server Error");
        }
      });
  };
  const handleShortlistRemove = (id) => {
    performRequest("PATCH", `/applyedcandidate/updateapplyedcandidate/${id}`, {
      shortlistBy: "",
      shortlistByRole: "",
      shortlistStatus: false,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Candidate removed from shortlisted list");
          setRefresh(!refresh);
        } else {
          Toast("error", "Server Error");
        }
      })
      .catch((err) => {
        console.error("Error", err);
        if (err.response.status === 401) {
          Toast("error", err.response.data.message);
        } else {
          Toast("error", "Server Error");
        }
      });
  };

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xxl">
            <div className="page-body">
              <div className="section-header">
                <h2 className="section-title section-title-lg m-0 p-0">
                  Resume details for candidate
                </h2>
                <p className="section-description mb-4 p-0">
                  Be as much specific as you can. It will help our recruiters
                  find right talent.
                </p>
              </div>
              {candidateDetails ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      justifyItems: "center",
                    }}
                  >
                    <div
                      ref={printRef}
                      style={{ maxWidth: "800px", minWidth: "800px" }}
                    >
                      <div className="card">
                        <div className="card-body">
                          <div className="row">
                            <div
                              className="col-md-4 card bg-secondary-lt p-2"
                              style={{ minHeight: "80vh" }}
                            >
                              <div>
                                <p className="text-center m-0 pb-2">
                                  {candidateDetails?.personalDetails?.[0] && (
                                    <img
                                      src={
                                        candidateDetails?.personalDetails?.[0]
                                          ?.profilePicture
                                      }
                                      alt="User Image"
                                      srcSet=""
                                    />
                                  )}
                                </p>
                              </div>

                              <p className="fs-5 m-0">
                                {candidateDetails.personalDetails?.[0]
                                  ?.email && (
                                  <FaEnvelope
                                    fontSize={"1.2em"}
                                    className="me-2"
                                  />
                                )}
                                {candidateDetails?.personalDetails?.[0]
                                  ?.email &&
                                  candidateDetails?.personalDetails?.[0]?.email}
                              </p>
                              <p className="fs-5 m-0">
                                {candidateDetails?.personalDetails?.[0]
                                  ?.mobile &&
                                  candidateDetails?.personalDetails?.[0]
                                    ?.mobile}
                              </p>
                              <p className="fs-5 m-0">
                                {candidateDetails?.personalDetails?.[0]
                                  ?.country &&
                                  candidateDetails?.personalDetails?.[0]
                                    ?.country}
                              </p>
                              <p className="fs-5 m-0">
                                {candidateDetails?.personalDetails?.[0]?.city &&
                                  candidateDetails?.personalDetails?.[0]?.city}
                                {candidateDetails?.personalDetails?.[0]?.city &&
                                  ","}
                                {candidateDetails?.personalDetails?.[0]
                                  ?.state &&
                                  candidateDetails?.personalDetails?.[0]?.state}
                              </p>

                              {candidateDetails?.education &&
                                candidateDetails?.education.length > 0 &&
                                Object.values(
                                  candidateDetails?.education?.[0]
                                ).some((value) => value !== "") && (
                                  <>
                                    <hr className="p-0 my-2" />
                                    <p className="p-0 mb-2 fs-3 fw-bold">
                                      <FaGraduationCap
                                        fontSize={"1em"}
                                        className="me-1"
                                      />
                                      Education
                                    </p>
                                  </>
                                )}

                              <>
                                {candidateDetails?.education &&
                                  candidateDetails?.education?.map(
                                    (el, index) => (
                                      <div key={index}>
                                        <h4 className="p-0 m-0 fs-4">
                                          {el.educationSelect1}
                                        </h4>
                                        <p className="p-0 m-0 fs-5">
                                          {el.university_1}
                                        </p>
                                        <p className="fs-5">
                                          {el.startDate1}
                                          <span>
                                            {el.endDate1 && "To"}
                                            {el.endDate1}
                                          </span>
                                        </p>
                                        <p className="fs-5">{el.summary}</p>
                                      </div>
                                    )
                                  )}
                              </>

                              {candidateDetails &&
                                candidateDetails.skills?.length > 0 && (
                                  <>
                                    <hr className="p-0 my-2" />
                                    <p className="p-0 mb-2 fs-3 fw-bold">
                                      <FaBook
                                        fontSize={"1em"}
                                        className="me-1"
                                      />{" "}
                                      Skills
                                    </p>
                                    <p className="m-0 p-0">
                                      {candidateDetails.skills?.map(
                                        (skills) => {
                                          return (
                                            <div
                                              className="avatar avatar-md m-1"
                                              style={{
                                                backgroundImage: `url(${skills.icon})`,
                                              }}
                                            ></div>
                                          );
                                        }
                                      )}
                                    </p>
                                    <hr className="p-0 my-2" />
                                  </>
                                )}
                              {candidateDetails?.languages &&
                                candidateDetails?.languages.length > 0 &&
                                Object.values(
                                  candidateDetails?.languages?.[0]
                                ).some((arr) => arr.length > 0) && (
                                  <>
                                    <>
                                      <p className="p-0 mb-2 fs-3 fw-bold">
                                        <FaLanguage
                                          fontSize={"1em"}
                                          className="me-1"
                                        />{" "}
                                        Languages
                                      </p>

                                      {candidateDetails?.languages &&
                                        candidateDetails?.languages?.[0]
                                          .languageSpeak?.length > 0 && (
                                          <>
                                            <p className="p-0 m-0 fs-4 fw-bold">
                                              Speak:
                                            </p>
                                            <p className="p-0 m-0">
                                              {candidateDetails?.languages?.[0]?.languageSpeak?.map(
                                                (el) => (
                                                  <span
                                                    className="badge badge-outline text-green me-1"
                                                    key={el}
                                                  >
                                                    {el}
                                                  </span>
                                                )
                                              )}
                                            </p>
                                          </>
                                        )}

                                      {candidateDetails?.languages &&
                                        candidateDetails?.languages?.[0]
                                          ?.readLanguage?.length > 0 && (
                                          <>
                                            <p className="p-0 m-0 fs-4 fw-bold">
                                              Read:
                                            </p>
                                            <p className="p-0 m-0">
                                              {candidateDetails?.languages?.[0]?.readLanguage.map(
                                                (el) => (
                                                  <span
                                                    className="badge badge-outline text-green me-1"
                                                    key={el}
                                                  >
                                                    {el}
                                                  </span>
                                                )
                                              )}
                                            </p>
                                          </>
                                        )}

                                      {candidateDetails.languages?.[0]
                                        ?.languageWrite.length > 0 && (
                                        <>
                                          <p className="p-0 m-0 fs-4 fw-bold">
                                            Write:
                                          </p>
                                          <p className="p-0 m-0">
                                            {candidateDetails.languages?.[0]
                                              ?.languageWrite.length > 0 ? (
                                              candidateDetails.languages?.[0]?.languageWrite.map(
                                                (el) => (
                                                  <span
                                                    className="badge badge-outline text-green me-1"
                                                    key={el}
                                                  >
                                                    {el}
                                                  </span>
                                                )
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </p>
                                        </>
                                      )}
                                    </>
                                  </>
                                )}

                              {candidateDetails.hobbies && (
                                <>
                                  <hr className="p-0 my-2" />
                                  <p className="p-0 mb-2 fs-3 fw-bold">
                                    <FaHands
                                      fontSize={"1em"}
                                      className="me-1"
                                    />
                                    Hobbies
                                  </p>
                                  <p>{candidateDetails?.hobbies}</p>
                                </>
                              )}
                            </div>
                            <div className="col-md-8">
                              <h1 className="p-0 m-0 fs-1">
                                {candidateDetails?.personalDetails?.[0] &&
                                  candidateDetails?.personalDetails?.[0]?.name}
                              </h1>

                              {candidateDetails?.personalDetails &&
                                candidateDetails?.personalDetails?.[0]
                                  ?.workProfile && (
                                  <>
                                    <p className="p-0 m-0 fs-4">
                                      <FaArrowCircleRight
                                        fontSize={"1em"}
                                        className="me-1"
                                      />{" "}
                                      <span>
                                        {" "}
                                        {candidateDetails?.personalDetails &&
                                          candidateDetails?.personalDetails?.[0]
                                            ?.workProfile}
                                      </span>
                                    </p>
                                  </>
                                )}

                              {candidateDetails?.additionalInformation &&
                                candidateDetails?.additionalInformation?.map(
                                  (el, index) => {
                                    return (
                                      <>
                                        <span className="badge badge-outline text-green my-1 me-1">
                                          {el}
                                        </span>
                                      </>
                                    );
                                  }
                                )}

                              {candidateDetails.description && (
                                <>
                                  <hr className="p-0 my-2" />
                                  <p className="p-0 m-0 fs-4 fw-bold">
                                    <FaLandmark
                                      fontSize={"1em"}
                                      className="me-1"
                                    />
                                    Professional Summary
                                  </p>
                                </>
                              )}

                              <p className="fs-5 ps-3">
                                {candidateDetails.description &&
                                  candidateDetails.description}
                              </p>
                              <hr className="p-0 my-2" />
                              {candidateDetails?.workExperience &&
                                candidateDetails?.workExperience.length > 0 &&
                                Object.values(
                                  candidateDetails?.workExperience?.[0]
                                ).some((value) => value !== "") && (
                                  <p className="p-0 m-0 fs-4 fw-bold">
                                    <FaUserAlt
                                      fontSize={"1em"}
                                      className="me-1"
                                    />
                                    Professional Experience
                                  </p>
                                )}

                              <div className="ps-3">
                                <>
                                  {candidateDetails?.workExperience &&
                                    candidateDetails?.workExperience.map(
                                      (el) => (
                                        <div key={el.position + el.companyName}>
                                          <p className="p-0 m-0 fs-4 fw-bold">
                                            {el.position}
                                          </p>
                                          <p className="p-0 m-0 fs-5">
                                            {el.companyName} <br />
                                            {el.location} <br />
                                            {el.locationType} <br />
                                            {el.joiningDate}{" "}
                                            {el.exitDate && "To"} {el.exitDate}
                                          </p>
                                          <p className="fs-5 pt-2">
                                            {el.jobDescription}
                                          </p>
                                        </div>
                                      )
                                    )}
                                </>
                              </div>

                              {candidateDetails?.awardAndCertificate &&
                                candidateDetails?.awardAndCertificate.length >
                                  0 &&
                                Object.values(
                                  candidateDetails?.awardAndCertificate?.[0]
                                ).some((value) => value !== "") && (
                                  <>
                                    <hr className="p-0 my-2" />
                                    <p className="p-0 m-0 fs-4 fw-bold">
                                      <FaTrophy
                                        fontSize={"1em"}
                                        className="me-1"
                                      />
                                      Awards & Certificates
                                    </p>
                                  </>
                                )}

                              <div className="ps-2">
                                <>
                                  {candidateDetails?.awardAndCertificate &&
                                    candidateDetails?.awardAndCertificate?.map(
                                      (el, index) => (
                                        <div key={index}>
                                          <p className="p-0 m-0 fs-4 fw-bold">
                                            {el.awardAndCertificateName}
                                          </p>
                                          <p className="p-0 m-0 fs-5">
                                            {el.givenBy}
                                          </p>
                                          <p className="fs-5 pt-2">
                                            {el.acDescription}
                                          </p>
                                        </div>
                                      )
                                    )}
                                </>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer text-center">
                    <button
                      className="btn  btn-primary m-1"
                      onClick={handleDownloadPdf}
                    >
                      <FaDownload fontSize={"1em"} className="me-2" /> Download
                      Resume
                    </button>
                    {viewApplicants?.shortlistStatus ? (
                      <button
                        className="btn  btn-primary m-1"
                        onClick={() => {
                          handleShortlistRemove(viewApplicants?.id);
                        }}
                      >
                        <FaRightToBracket fontSize={"1em"} className="me-2" />{" "}
                        Cancel Shortlist Candidate
                      </button>
                    ) : (
                      <button
                        className="btn  btn-primary m-1"
                        onClick={() => {
                          handleShortlist(viewApplicants?.id);
                        }}
                      >
                        <FaRightToBracket fontSize={"1em"} className="me-2" />{" "}
                        Shortlist Candidate
                      </button>
                    )}
                  </div>
                </>
              ) : (
                <div className="page-body">
                  <h3>Resume details not available for this candidate</h3>
                </div>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AppliedCandidateResume;
